export const CONSTANT_APPROVERS = {
    SLACK_CHANNEL_LABEL: 'Slack Channel: ',
    NO_SLACK_CHANNEL_LABEL: 'No Slack Channel available.',
    NO_APPROVAL_REQD: 'No approval required',
    NO_APPROVAL_REQD_DETAIL: 'Account owners do not require an approval for this role.',
    NO_APPROVAL_REQD_DETAIL_ADDITIONAL: 'Request will be auto-approved',
    NOTE_LABEL: 'NOTE: ',
    SRE: 'SRE',
    SRE_NOTE: 'SRE can only approve requests created by SREs or account approvers (members of the Approvers group managed by IAM).',
}